module.exports = __webpack_public_path__ + "static/media/finport-logo-black.5937fff2.png";